<template>
  <div class="content-box">
    <Loader v-if="loading" />
    <div class="full-chat-w" v-else>

      <div class="full-chat-i">
        <div class="full-chat-left scrollable">
             <WorklistFilters :filterFormData="{}" @filterInterface="{}" :appliedFilters="[]" :filters="{}"/>
            </div>
        <div class="full-chat-left scrollable">
          <div class="chat-search">
            <div class="element-search"><input placeholder="Search products..." type="text"></div>
          </div>
          <div class="ae-list-w">
            <div class="ael-head">
              <div class="actions-left">
                <h5>{{pendingProducts.length}} Products</h5>
                <!-- <div class="input-search-w"><input class="form-control rounded bright" @input="isTyping = true" v-model="searchString"  placeholder="Type to filter..." type="search"></div> -->
              </div>
              <div class="actions-right">
                <div class="btn-group">
                  <button
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="btn dropdown-toggle"
                    data-toggle="dropdown"
                    type="button"
                    style="padding-left: 0; background: #f2f4f8;"
                  >
                    <h6 class="dispatch-location">Bulk Action</h6>
                  </button>
                  <div
                    aria-labelledby="export-button"
                    class="dropdown-menu"
                    x-placement="top-start"
                  >
                    <a
                      class="dropdown-item"
                      @click="actionPendingProductBulk(1)"
                      >Approve All</a
                    >
                    <a
                      class="dropdown-item"
                      @click="actionPendingProductBulk(0)"
                      >Reject All</a
                    >
                  </div>
                </div>
                <a @click="refreshProductRail">
                  <i class="os-icon os-icon-grid-18" :class="{'fa fa-spin' :  loadingPendingRail}"></i>
                </a>
              </div>
            </div>
            <div class="ae-list">
              <Loader v-if="loadingPendingRail" />
              <ProductRail :products="pendingProducts" :selectedProduct="selectedProduct" @productRailInterface="updateSelectedProduct" v-else/>
            </div>
          </div>
        </div>
        <div class="full-chat-right scrollable border-right">
          <EmptyState v-if="selectedProduct == ''">
            <div slot="empty_state_text">
              Select a product to see details
            </div>
          </EmptyState>
          <ProductInfoBlock :selectedProduct="selectedProduct" :session="session" :type="'copydesk'" v-else/>
        </div>
        <div class="full-chat-middle">
          <div class="chat-head">
            <div class="user-info">
              <div v-show="loadingProduct == false && waitingForAction == false">
                <div v-if="viewMode == 'view'">
                  <button class="mr-2 mb-2 btn btn-success btn-sm" type="button" @click="actionPendingProduct(1)" > Approve Draft</button>
                  <button class="mr-2 mb-2 btn btn-danger btn-sm" type="button" @click="actionPendingProduct(0)" > Reject Draft</button>
                  <button class="mr-2 mb-2 btn btn-primary btn-sm" type="button" @click="editProduct" > Edit Revision</button>
                </div>
                <div v-else>
                  <button class="mr-2 mb-2 btn btn-primary btn-sm" type="button" @click="actionPendingProductWrite"> Submit for Review</button>
                  <button class="mr-2 mb-2 btn btn-primary btn-sm" type="button" @click="editProduct" > Cancel</button>
                </div>

              </div>
            </div>
          </div>
          <div class="chat-head">
            <div class="user-info">
              <div v-show="loadingProduct == false && waitingForAction == false">
                <div v-if="selectedProduct.is_dispatch_success == 0" 
                
                class="text-danger">
                  This product previously failed at copy dispatch with message: {{selectedProduct.notes}}
                </div>

              </div>
            </div>
          </div>
          <div class="chat-content-w">
            <EmptyState v-if="waitingForAction">
              <div slot="empty_state_text" v-if="pendingProducts.length > 0">
                Select a product to continue
              </div>
              <div slot="empty_state_text" v-else>
                There are no products in queue
              </div>
            </EmptyState>
            <div v-else>
              <Loader v-if="loadingProduct || revisionFilters.loadingRevision" />
              <Workspace
                :product="selectedProduct"
                :headers="selectedProductCopy"
                :template="selectedProductTemplate"
                :primaryLanguage="session.language_code"
                @copyInterface="updateCopyFormData"
                v-else-if="revisionFilters.selected == 'current_draft'" />
              <RevisionWorkspace :product="selectedProduct" :revision="revisionFilters.selectedRevision" :primaryLanguage="session.language_code" v-else />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader'
import Placeholder from '@/components/common/Placeholder'
import EmptyState from '@/components/common/EmptyState'
import Modal from '@/components/common/Modal'

import ProductRail from '@/components/common/SessionAdd/ProductRail'
import ProductInfoBlock from '@/components/common/SessionAdd/ProductInfoBlock'

import Workspace from '@/components/copydesk/Workspace'
import RevisionWorkspace from '@/components/copydesk/RevisionWorkspace'
import WorklistFilters from '@/components/reportdesk/WorklistFilters'

import Session from '@/mixins/session'

import { debounce } from 'underscore'

export default {
  name: 'session-view',
  mixins: [Session],
  components: {
    Loader,
    EmptyState,
    Workspace,
    RevisionWorkspace,
    ProductRail,
    Placeholder,
    ProductInfoBlock,
    WorklistFilters
  },
  props: ['id_session'],
  data: function () {
    return {
      session: '',
      selectedQueue: 'photodesk',
      pendingProducts: [],
      selectedProduct: '',
      selectedProductCopy: '',
      selectedProductRevisions: '',
      selectedProductTemplate: '',
      selectedProductCompletion: '',
      selectedProductWriteSession: '',
      loading: false,
      loadingPendingRail: true,
      loadingProduct: true,
      waitingForAction: true,
      revisionState: 'loading',
      viewMode: 'view',
      revisionFilters: {
        loadingRevision: false,
        filterOptions: [],
        selected: '',
        selectedRevision: ''
      },
      copyFormData: '',
      isFormChanged: false
    }
  },
  mounted: function () {
    this.getSessionDetails()
  },
  methods: {
    removeKeys (obj, keys) {
      var index
      var self = this
      for (var prop in obj) {
        // important check that this is objects own property
        // not from prototype prop inherited
        if (obj.hasOwnProperty(prop)) {
          switch (typeof (obj[prop])) {
            case 'string':
              index = keys.indexOf(prop)
              if (index > -1) {
                delete obj[prop]
              }
              break
            case 'object':
              index = keys.indexOf(prop)
              if (index > -1) {
                delete obj[prop]
              } else {
                self.removeKeys(obj[prop], keys)
              }
              break
          }
        }
      }
    },
    updateCopyFormData (data) {
      this.removeKeys(data, ['children', 'options'])
      this.copyFormData = data
      this.isFormChanged = true
    },
    getSessionDetails: function () {
      var self = this

      const url = '/copydesk/session/show'
      let data = {
        id_copydesk_session: self.id_session
      }

      self.$store.dispatch('updateLoading', 'true')
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
          // mode: 'no-cors',
        })
        .then(function (response) {
          self.session = response.data.session
          self.getPendingProducts()
          self.$store.dispatch('updateLoading', 'false')
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateLoading', 'false')
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
        })
    },
    getPendingProducts: function () {
      var self = this
      var search =
        this.searchString != '' ? '&search=' + this.searchString : ''

      const url = '/copydesk/session/products/pending/review'
      let data = {
        id_copydesk_session: self.session.id_copydesk_session,
        queue: self.selectedQueue
      }

      self.loadingPendingRail = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.pendingProducts = response.data
          self.loadingPendingRail = false
        })
        .catch(function (error) {
          // add toast message
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingPendingRail = false
        })
    },
    actionPendingProductBulk: function (action) {
      var self = this

      const actionText = action == 1 ? 'approve ' : 'reject '
      const productsLength = this.pendingProducts.length

      if (!confirm('Are you sure you want to ' + actionText + productsLength + ' products?')) {
        console.log(this.pendingProducts[0])
        return
      }

      const url = '/copydesk/session/products/review'

      let id_products = self.pendingProducts.map(function (product, index, array) {
        return product.id_product
      })

      let data = {
        id_copydesk_session_review: self.id_session,
        id_copydesk_session: self.selectedProductWriteSession,
        id_product: id_products.toString(),
        is_approve: action,
        id_language: self.session.id_language
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.$store.dispatch('updateToast', {
            text: 'Products reviewed',
            show: true
          })
          self.refreshProductRail()
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingPendingRail = false
        })
    },
    actionPendingProduct: function (is_approve) {
      // check if product is complete here

      var self = this

      var completion = self.selectedProductCompletion[self.session.language_code][0]

      var completed_headers = completion['required_headers_complete'] && completion['required_headers_complete'] || 0
      var required_headers = completion['required_headers'] && completion['required_headers'] || 0

      if (parseInt(completed_headers) != parseInt(required_headers)) {
        return alert('this product is missing required headers')
      }

      const url = '/copydesk/session/products/review'
      const id_products = []

      id_products.push(self.selectedProduct.id_product)

      let data = {
        id_copydesk_session_review: self.id_session,
        id_copydesk_session: self.selectedProductWriteSession,
        id_product: id_products.toString(),
        is_approve: is_approve,
        id_language: self.session.id_language
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.$store.dispatch('updateToast', {
            text: 'Draft reviewed',
            show: true
          })
          self.loadNextProduct()
          // self.refreshProductRail();
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingPendingRail = false
        })
    },
    loadNextProduct: function () {
      var self = this

      self.pendingProducts.find((o, i) => {
        if (o.id_product == self.selectedProduct.id_product) {
          self.pendingProducts.splice(i, 1)
          return true
        }
      })
      if (self.pendingProducts.length > 0) {
        self.selectedProduct = this.pendingProducts[0]
        self.waitingForAction = true
        self.updateSelectedProduct(self.selectedProduct)
      } else {
        self.selectedProduct = ''
        self.waitingForAction = true
      }
    },
    actionPendingProductWrite: function () {
      var self = this
      const url = '/copydesk/product/revision/add'

      let data = {
        id_copydesk_session: self.id_session,
        id_product: self.selectedProduct.id_product,
        copy_data: self.copyFormData
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.$store.dispatch('updateToast', {
            text: 'Draft saved',
            show: true
          })
          self.getProductInformation()
          self.submitForReview()
          self.revisionFilters.selected = ''
          self.viewMode = 'view'
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingPendingRail = false
        })
    },
    submitForReview: function () {
      var self = this
      const url = '/copydesk/product/submit'

      let data = {
        id_copydesk_session: self.id_session,
        id_product: self.selectedProduct.id_product
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.$store.dispatch('updateToast', {
            text: 'Draft submitted',
            show: true
          })
          self.getProductInformation()
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingPendingRail = false
        })
    },
    getProductInformation: function () {
      var self = this
      const url = '/copydesk/product/details/'
      let data = {
        id_product: self.selectedProduct.id_product
      }

      this.loadingProduct = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.selectedProduct = response.data.product
          self.selectedProductCopy = response.data.product_copy
          self.selectedProductRevisions = response.data.copy_revisions
          self.selectedProductTemplate = response.data.copy_template
          self.selectedProductCompletion = response.data.completion
          self.loadLastRevision()
          self.loadingProduct = false
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data) || 'Something went wrong',
            show: true
          })
          self.loadingProduct = false
        })
    },
    refreshProductRail: function () {
      this.getPendingProducts()
      this.selectedProduct = ''
      this.waitingForAction = true
      // this.revisionFilters.selected = "current_draft";
    },
    updateSelectedProduct: function (data) {
      this.selectedProduct = data
      this.getProductInformation()
      this.waitingForAction = false
      // this.revisionFilters.selected = "current_draft";
    },
    getFilterOptions: function () {
      var self = this
      self.revisionFilters.selectedRevision = ''
      self.revisionFilters.filterOptions = []
      self.selectedProductRevisions.forEach(function (revision, index) {
        let obj = self.revisionFilters.filterOptions.find(
          o => o.key === revision.id_copydesk_session
        )
        if (obj == null || obj == '' || obj == undefined) {
          self.revisionFilters.filterOptions.push({
            value: 'Session ' + revision.id_copydesk_session,
            key: revision.id_copy_revision
          })
        }
      })
    },

    loadLastRevision: function () {
      // Here we check if the revisions has the language key we are looking for
      // Other we will get the last one
      var self = this
      self.revisionFilters.selectedRevision = ''
      self.revisionFilters.filterOptions = []

      let lastRevision = self.selectedProductRevisions[0]
      self.selectedProductRevisions.forEach(function (revision, index) {
        var rev = JSON.parse(revision.revision)
        let revision_lang = Object.keys(rev)
        if (self.session.language_code == revision_lang[0]) {
          lastRevision = revision
        }
      })
      self.revisionFilters.selectedRevision = lastRevision.id_copy_revision
      self.selectedProductWriteSession = lastRevision.id_copydesk_session
    },
    editProduct: function () {
      var self = this
      self.revisionFilters.selected = (self.viewMode == 'view' ? 'current_draft' : '')
      self.viewMode = (self.viewMode == 'view' ? 'edit' : 'view')
    },
    updateRevision: function (revision) {
      var self = this
      self.revisionFilters.loadingRevision = true
      const filter = self.revisionFilters.filterOptions.find(value => {
        return value.key == revision
      })
      console.log(filter)
      if (filter && filter.key) {
        self.revisionFilters.selectedRevision = filter.key
      } else {
        self.revisionFilters.selectedRevision = ''
      }

      if (filter && filter.value) {
        self.revisionFilters.selected = filter.value
      } else {
        self.revisionFilters.selectedRevision = 'current_draft'
      }

      self.revisionFilters.loadingRevision = false
    },
    onFilterRevisionChange: function () {
      var self = this
      this.updateRevision(self.revisionFilters.selected)
    }
  },
  watch: {
    selectedQueue () {
      this.refreshProductRail()
    }
  }
}
</script>

<style scoped>
.full-chat-w .user-intro .user-intro-info {
  margin-top: 14px !important;
}
.border-right {
  border-right: 1px solid #f6f7f8;
}
.full-chat-w .full-chat-left .os-tabs-w .nav {
  padding: 0px 20px;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.full-chat-w .full-chat-left .chat-search {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.full-chat-w .chat-content-w {
  height: calc(100vh - 98px);
  overflow-y: scroll;
  position: relative;
}
.qc-1 {
  color: #75da62 !important;
}

.qc-0 {
  color: #da6262 !important;
}

.flagged {
  color: #ffc107 !important;
}
.ae-list-w {
  background-color: #f2f4f8;
}
.element-wrapper .element-search input {
  background-color: #fff;
  border-radius: 0px !important;
}

.full-chat-w .full-chat-left {
  padding: 0px !important;
}

.element-wrapper {
  padding-bottom: 0rem !important;
}

.os-tab {
  position: absolute;
  top: 0;
  width: 340px;
  background: #f2f4f8;
  z-index: 999;
}

.tab-container {
  margin-top: 53px;
}

.side-section .side-section-content {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px 0px;
}

.property-side-features .feature {
  padding: 15px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  font-size: 0.72rem;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 1px;
}

.property-side-features .feature i,
.property-side-features .feature span,
.property-side-features .feature strong {
  display: inline-block;
  vertical-align: middle;
}

.property-side-features .feature span {
  color: rgba(0, 0, 0, 0.6);
}

.property-side-features .feature strong {
  margin-right: 3px;
  color: #111;
}

.property-side-features .feature i {
  color: #047bf8;
  font-size: 15px;
  margin-right: 20px;
}

.property-side-features .feature:last-child {
  border-bottom: none;
}
.user-name {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.user-title {
  margin-bottom: 4px;
}
.user-role {
  font-size: 0.63rem;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.4);
  margin-bottom: 10px;
}

.chat-head {
  min-height: 53px;
}
</style>
